"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormGroup = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
require("./form-group.scss");
const form_group_html_1 = __importDefault(require("./form-group.html"));
let ItpFormGroup = class ItpFormGroup extends vue_1.default {
    validationState;
    componentContext;
    labelAlignInternal;
    contentClassInternal;
    id;
    name;
    label;
    labelClass;
    labelFor;
    labelAlign;
    helpText;
    helpTooltip;
    inline;
    prependText;
    appendText;
    contentClass;
    description;
    childInputIdentities;
    labelCols;
    labelColsMd;
    contentCols;
    contentColsMd;
    colsMd;
    row;
    listGroupItem;
    required;
    disabled;
    formCheck;
    plainContent;
    onContentClassChanged() {
        this.contentClassInternal = this.getContentClass();
    }
    onPlainContentChanged() {
        this.contentClassInternal = this.getContentClass();
    }
    data() {
        return {
            validationState: null,
            labelAlignInternal: this.labelAlign,
            contentClassInternal: this.getContentClass()
        };
    }
    get labelText() {
        if (this.label) {
            return this.required ? `${this.label} *` : this.label;
        }
        return null;
    }
    get className() {
        const result = {
            'form-check': this.formCheck,
            'list-group-item': this.listGroupItem
        };
        if (this.row || this.listGroupItem) {
            result['row'] = true;
            return result;
        }
        if (this.colsMd != null) {
            result[`col-md-${this.colsMd}`] = true;
        }
        return result;
    }
    get labelClassInternal() {
        return [
            {
                'mx-2': this.inline,
                'label-align-right': this.labelAlignInternal == 'right',
                'font-weight-bold': true
            },
            this.labelClass
        ];
    }
    get labelForInternal() {
        return this.labelFor || this.name;
    }
    get state() {
        return this.validationState && this.validationState.errors.length
            ? false
            : null;
    }
    get invalidFeedback() {
        return this.validationState && this.validationState.errors
            ? this.validationState.errors[0]
            : null;
    }
    get hasInputGroup() {
        return this.hasInputGroupAppend || this.hasInputGroupPrepend;
    }
    get hasInputGroupAppend() {
        return this.appendText || this.$slots['append'];
    }
    get hasInputGroupPrepend() {
        return this.prependText || this.$slots['prepend'];
    }
    get contentColsMdInternal() {
        if (this.labelColsMd && !this.contentColsMd) {
            return 'auto';
        }
        return this.contentColsMd;
    }
    mounted() {
        this.componentContext.$on('input:validated', this.onChildValidationState);
        this.$nextTick(() => this.applyParentFormProperties());
    }
    beforeDestroy() {
        this.componentContext.$off('input:validated');
    }
    onChildValidationState(args) {
        if (this.childInputIdentities &&
            this.childInputIdentities.indexOf(args.id) > -1) {
            this.validationState = args;
        }
    }
    applyParentFormProperties() {
        const parentForm = this.findParentForm();
        if (parentForm) {
            if (!this.labelAlign && parentForm.$props.labelAlign) {
                this.labelAlignInternal = parentForm.$props.labelAlign;
            }
        }
    }
    findParentForm() {
        let parent = this.$parent;
        while (parent && _.get(parent.$options, '_componentTag') !== 'ItpForm') {
            parent = parent.$parent;
        }
        return parent;
    }
    getContentClass() {
        const result = {};
        if (_.isObject(this.contentClass)) {
            _.extend(result, this.contentClass);
        }
        else if (_.isString(this.contentClass)) {
            result[this.contentClass] = true;
        }
        if (this.plainContent) {
            result['form-control-plaintext'] = true;
        }
        return result;
    }
};
exports.ItpFormGroup = ItpFormGroup;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "label", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "labelClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "labelFor", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "helpText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "helpTooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "inline", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "prependText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "appendText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "contentClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormGroup.prototype, "description", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Array)
], ItpFormGroup.prototype, "childInputIdentities", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "labelCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "labelColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "contentCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "contentColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpFormGroup.prototype, "colsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "listGroupItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "required", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "formCheck", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormGroup.prototype, "plainContent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contentClass'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpFormGroup.prototype, "onContentClassChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('plainContent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpFormGroup.prototype, "onPlainContentChanged", null);
exports.ItpFormGroup = ItpFormGroup = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_group_html_1.default,
        inject: {
            componentContext: 'componentContext'
        }
    })
], ItpFormGroup);
//# sourceMappingURL=form-group.js.map